import React from 'react';
import { FaWhatsapp} from 'react-icons/fa';

class DisplayPhone extends React.Component {
  render() {
    const phone = this.props.phone.replace('-', '').replace('+', '');
    return (
      <>        
        <span className="leadvalue">
          <span className="phoneicon wtspicon">
            <a href={`https://api.whatsapp.com/send?phone=${phone}`}
              target="_blank" rel="noreferrer"><FaWhatsapp /></a>
          </span>
           <span className="phoneicons"><a href={`tel:${phone}`}>{this.props.phone}</a></span>
        </span>
        <br></br>
      </>
    );
  }
}
export default DisplayPhone;